(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-product-cta"] && !Shopify.designMode) return;
  try {
    
class StickyProductCta extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.select = this.querySelector('[data-sticky-cta-select]');
    this.hiddenInput = this.querySelector('[data-sticky-cta-variant-input]');
    this.priceEl = this.querySelector('[data-sticky-cta-price]');
    this.compareEl = this.querySelector('[data-sticky-cta-compare]');
    this.imageEl = this.querySelector('[data-sticky-cta-image]');
    this.button = this.querySelector('[data-sticky-cta-submit]');
    this.buttonText = this.querySelector('[data-sticky-cta-button-text]');
    this.errorEl = this.querySelector('[data-sticky-cta-error]');
    this.variants = this.readVariantData();
    this.visible = false;
    this.syncing = false;
    this.forcedOpen = false;
    this.highlightTimer = null;
  }

  get isScrollMode() {
    return this.dataset.buttonAction === 'scroll';
  }

  connectedCallback() {
    this.setAttribute('inert', '');
    this.routes = window.routes || {};
    this.cartElement =
      document.querySelector('cart-drawer') || document.querySelector('cart-notification') || null;

    if (this.form) this.form.addEventListener('submit', this.onSubmit.bind(this));
    if (this.select) this.select.addEventListener('change', this.onSelectChange.bind(this));

    if (this.isScrollMode && this.button) {
      this.button.addEventListener('click', (event) => {
        event.preventDefault();
        this.scrollToTarget();
      });
    }

    this.watchTrigger();
    this.watchMainForm();
    this.watchSize();
    this.watchDesignMode();
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
    if (this.resizeObserver) this.resizeObserver.disconnect();
    if (this.scrollHandler) window.removeEventListener('scroll', this.scrollHandler);
    if (this.highlightTimer) clearTimeout(this.highlightTimer);
    document.documentElement.style.removeProperty('--sticky-product-cta-height');
  }

  /* ---------- data ---------- */

  readVariantData() {
    const script = this.querySelector('[data-sticky-cta-variant-data]');
    if (!script) return [];
    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return [];
    }
  }

  get currentVariantId() {
    const input = this.select || this.hiddenInput;
    return input ? String(input.value) : null;
  }

  findVariant(id) {
    return this.variants.find((variant) => String(variant.id) === String(id)) || null;
  }

  /* ---------- visibility ---------- */

  get mainSelector() {
    return this.dataset.triggerSelector || '.product-form__submit';
  }

  findTrigger() {
    let matches = [];
    try {
      matches = Array.from(document.querySelectorAll(this.mainSelector));
    } catch (error) {
      matches = [];
    }
    return matches.find((el) => !this.contains(el)) || null;
  }

  watchTrigger() {
    this.trigger = this.findTrigger();

    if (this.trigger && 'IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const scrolledPast = entry.boundingClientRect.top < 0;
            if (!entry.isIntersecting && scrolledPast) {
              this.show();
            } else {
              this.hide();
            }
          });
        },
        { threshold: 0 }
      );
      this.observer.observe(this.trigger);
      return;
    }

    if (this.dataset.scrollFallback === 'true') {
      this.scrollHandler = () => {
        if (window.scrollY > 600) {
          this.show();
        } else {
          this.hide();
        }
      };
      window.addEventListener('scroll', this.scrollHandler, { passive: true });
      this.scrollHandler();
    }
  }

  /* Dawn can replace the product form markup when the variant changes, which
     detaches the observed node. Re-attach the observer if that happens. */
  refreshTrigger() {
    if (!this.observer) return;
    if (this.trigger && document.contains(this.trigger)) return;

    const next = this.findTrigger();
    if (!next) return;

    this.observer.disconnect();
    this.trigger = next;
    this.observer.observe(next);
  }

  show() {
    if (this.visible) return;
    this.visible = true;
    this.classList.add('sticky-cta--visible');
    this.classList.remove('sticky-cta--hidden');
    this.setAttribute('aria-hidden', 'false');
    this.removeAttribute('inert');
    this.measure();
  }

  hide() {
    if (this.forcedOpen || !this.visible) return;
    this.visible = false;
    this.classList.remove('sticky-cta--visible');
    this.classList.add('sticky-cta--hidden');
    this.setAttribute('aria-hidden', 'true');
    this.setAttribute('inert', '');
    document.documentElement.style.setProperty('--sticky-product-cta-height', '0px');
  }

  measure() {
    if (!this.visible) return;
    const height = this.offsetHeight;
    document.documentElement.style.setProperty('--sticky-product-cta-height', `${height}px`);
  }

  watchSize() {
    if (!('ResizeObserver' in window)) return;
    this.resizeObserver = new ResizeObserver(() => this.measure());
    this.resizeObserver.observe(this);
  }

  watchDesignMode() {
    if (!window.Shopify || !window.Shopify.designMode) return;

    document.addEventListener('shopify:section:select', (event) => {
      if (!event.target.contains(this)) return;
      this.forcedOpen = true;
      this.show();
    });

    document.addEventListener('shopify:section:deselect', (event) => {
      if (!event.target.contains(this)) return;
      this.forcedOpen = false;
      this.hide();
    });
  }

  /* ---------- scroll to product form ---------- */

  findScrollTarget() {
    const selector = this.dataset.scrollTarget || '.product-form';
    let matches = [];
    try {
      matches = Array.from(document.querySelectorAll(selector)).filter((el) => !this.contains(el));
    } catch (error) {
      matches = [];
    }

    /* Prefer a target that is actually rendered (not display:none) */
    const rendered = matches.find((el) => el.getClientRects().length > 0);
    if (rendered) return rendered;
    if (matches.length) return matches[0];

    /* Fall back to the main Add to cart button, then the product info column */
    if (this.trigger && document.contains(this.trigger) && this.trigger.getClientRects().length > 0) {
      return this.trigger;
    }
    return document.querySelector('.product__info-wrapper') || document.querySelector('.product') || null;
  }

  scrollToTarget() {
    const target = this.findScrollTarget();
    const reduceMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const behavior = reduceMotion ? 'auto' : 'smooth';

    if (!target) {
      window.scrollTo({ top: 0, behavior });
      return;
    }

    const offset = parseInt(this.dataset.scrollOffset, 10) || 0;
    const top = target.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({ top: Math.max(0, top), behavior });

    /* The bar becomes inert once it hides, so move focus to the offers for
       keyboard and screen reader users. */
    if (!target.hasAttribute('tabindex')) {
      target.setAttribute('tabindex', '-1');
      target.classList.add('sticky-cta-scroll-target');
    }
    try {
      target.focus({ preventScroll: true });
    } catch (error) {
      /* older browsers ignore preventScroll */
    }

    if (this.dataset.scrollHighlight === 'true') this.highlight(target, reduceMotion ? 0 : 450);
  }

  highlight(target, delay) {
    if (this.highlightTimer) clearTimeout(this.highlightTimer);
    const color = this.dataset.scrollHighlightColor;
    if (color) target.style.setProperty('--sticky-cta-highlight-color', color);

    this.highlightTimer = setTimeout(() => {
      target.classList.remove('sticky-cta-target-highlight');
      void target.offsetWidth; /* restart the animation on repeat clicks */
      target.classList.add('sticky-cta-target-highlight');

      this.highlightTimer = setTimeout(() => {
        target.classList.remove('sticky-cta-target-highlight');
        this.highlightTimer = null;
      }, 1700);
    }, delay);
  }

  /* ---------- variant syncing ---------- */

  onSelectChange() {
    this.applyVariant(this.findVariant(this.currentVariantId));
    if (this.dataset.syncMain === 'true') this.syncMainForm();
  }

  applyVariant(variant) {
    if (!variant) return;

    if (this.priceEl) this.priceEl.textContent = variant.price;

    if (this.compareEl) {
      if (variant.compare_at_price) {
        this.compareEl.textContent = variant.compare_at_price;
        this.compareEl.hidden = false;
      } else {
        this.compareEl.textContent = '';
        this.compareEl.hidden = true;
      }
    }

    if (this.imageEl && variant.image) {
      this.imageEl.src = variant.image;
      this.imageEl.srcset = `${variant.image} 1x, ${variant.image_2x || variant.image} 2x`;
    }

    /* In scroll mode the button always leads to the offers, so never disable it */
    if (this.button && !this.isScrollMode) {
      this.button.disabled = !variant.available;
      if (this.buttonText) {
        this.buttonText.textContent = variant.available
          ? this.button.dataset.addLabel
          : this.button.dataset.soldOutLabel;
      }
    }

    this.clearError();
  }

  selectVariant(id) {
    const variant = this.findVariant(id);
    if (!variant) return;

    if (this.select && String(this.select.value) !== String(id)) this.select.value = String(id);
    if (this.hiddenInput) this.hiddenInput.value = String(id);

    this.applyVariant(variant);
  }

  mainProductRoot() {
    return (
      document.querySelector('.product__info-wrapper') ||
      document.querySelector('.product') ||
      document.body
    );
  }

  syncMainForm() {
    const variant = this.findVariant(this.currentVariantId);
    if (!variant || !Array.isArray(variant.options)) return;

    const root = this.mainProductRoot();
    const pickers = Array.from(
      root.querySelectorAll('variant-selects .product-form__input, variant-radios .product-form__input, .product-form__input')
    ).filter((el) => !this.contains(el));

    if (!pickers.length) return;

    this.syncing = true;

    pickers.forEach((picker, index) => {
      const value = variant.options[index];
      if (typeof value === 'undefined') return;

      const select = picker.querySelector('select');
      if (select) {
        if (select.value !== value) {
          select.value = value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }

      const radios = Array.from(picker.querySelectorAll('input[type="radio"]'));
      const match = radios.find((radio) => radio.value === value);
      if (match && !match.checked) {
        match.checked = true;
        match.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    setTimeout(() => {
      this.syncing = false;
      this.refreshTrigger();
    }, 500);
  }

  readMainVariantId() {
    const root = this.mainProductRoot();
    const input = Array.from(root.querySelectorAll('form [name="id"]')).find(
      (el) => !this.contains(el)
    );
    return input ? input.value : null;
  }

  watchMainForm() {
    /* Dawn 10+ pub/sub */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (this.syncing) return;
        const id = event && event.data && event.data.variant ? event.data.variant.id : null;
        if (id) this.selectVariant(id);
        this.refreshTrigger();
      });
    }

    /* Newer themes dispatch a DOM event */
    document.addEventListener('variant:change', (event) => {
      if (this.syncing) return;
      const id = event.detail && event.detail.variant ? event.detail.variant.id : null;
      if (id) this.selectVariant(id);
      this.refreshTrigger();
    });

    /* Fallback: read the main form's variant input after any picker change */
    document.addEventListener('change', (event) => {
      if (this.syncing || this.contains(event.target)) return;
      if (!event.target.closest('form[action*="/cart/add"], variant-selects, variant-radios, .product-form__input')) {
        return;
      }
      setTimeout(() => {
        const id = this.readMainVariantId();
        if (id && id !== this.currentVariantId) this.selectVariant(id);
        this.refreshTrigger();
      }, 400);
    });
  }

  /* ---------- add to cart ---------- */

  setLoading(state) {
    this.classList.toggle('sticky-cta--loading', state);
    if (!this.button) return;
    this.button.setAttribute('aria-disabled', String(state));
    if (state) {
      this.button.setAttribute('aria-busy', 'true');
    } else {
      this.button.removeAttribute('aria-busy');
    }
  }

  showError(message) {
    if (!this.errorEl) return;
    this.errorEl.textContent = message;
    this.errorEl.hidden = false;
    this.measure();
  }

  clearError() {
    if (!this.errorEl) return;
    this.errorEl.textContent = '';
    this.errorEl.hidden = true;
  }

  sectionsToRender() {
    if (!this.cartElement || typeof this.cartElement.getSectionsToRender !== 'function') return null;
    try {
      return this.cartElement
        .getSectionsToRender()
        .map((section) => section.id)
        .join(',');
    } catch (error) {
      return null;
    }
  }

  onSubmit(event) {
    event.preventDefault();

    /* Enter key inside the form in scroll mode: scroll instead of adding */
    if (this.isScrollMode) {
      this.scrollToTarget();
      return;
    }

    if (!this.button || this.button.getAttribute('aria-disabled') === 'true' || this.button.disabled) {
      return;
    }

    this.clearError();
    this.setLoading(true);

    const formData = new FormData(this.form);
    const sections = this.sectionsToRender();
    if (sections) {
      formData.append('sections', sections);
      formData.append('sections_url', window.location.pathname);
    }
    if (this.cartElement && typeof this.cartElement.setActiveElement === 'function') {
      this.cartElement.setActiveElement(document.activeElement);
    }

    fetch(`${this.routes.cart_add_url || '/cart/add'}`, {
      method: 'POST',
      headers: {
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.showError(response.description || response.message || 'Could not add to cart.');
          return;
        }

        if (this.cartElement && typeof this.cartElement.renderContents === 'function' && sections) {
          this.cartElement.classList.remove('is-empty');
          this.cartElement.renderContents(response);
        } else {
          window.location = this.routes.cart_url || '/cart';
          return;
        }

        try {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'sticky-product-cta',
              productVariantId: formData.get('id')
            });
          }
        } catch (error) {
          /* pub/sub is optional */
        }
      })
      .catch(() => {
        this.showError('Something went wrong. Please try again.');
      })
      .finally(() => {
        this.setLoading(false);
      });
  }
}

if (!customElements.get('sticky-product-cta')) {
  customElements.define('sticky-product-cta', StickyProductCta);
}

  } catch(e) { console.error(e); }
})();
})();
